<template>
	<div class="subPopuCanvas" :class="className"></div>
</template>

<script>
import echarts from 'echarts'
export default {
	props: {
		classData: Array,
		classDataTitle: Array,
		FractionX: Array,
		max: Number,
		interval: Number,
		title: String,
		className: {
			type: String,
			default: 'subPopuCanvas1'
		}
	},
	data() {
		return {
			newSubSection: []
		}
	},
	watch: {
		classDataTitle: {
			handler() {}
		},
		classData: {
			handler() {
				this.drawSubSectionPopulation()
			}
		}
	},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			this.getData()
		},
		getData() {
			// for (const item of this.subsection) {
			// 	if (item.class === '2班') {
			// 		for (const key in item) {
			// 			this.newSubSection.push(item[key])
			// 		}
			// 	}
			// }
			this.$nextTick(() => {
				this.drawSubSectionPopulation()
			})
		},
		drawSubSectionPopulation() {
			this.renderSubPopu = echarts.init(document.querySelector(`.${this.className}`))
			this.renderSubPopu.clear()
			this.renderSubPopu.setOption({
				legend: {
					selectedMode: false,
					data: this.classDataTitle.map(item => item.className),
					padding: [20, 0, 0, 0]
				},
				color: ['rgb(0,153,255)', 'rgb(51,204,51)', 'rgb(51,204,204)'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						// 坐标轴指示器，坐标轴触发有效
						type: '' // 默认为直线，可选为：'line' | 'shadow'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						data: this.FractionX.map(item => item.label + '分'),
						axisTick: {
							alignWithLabel: false,
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						name: this.title,
						min: 0,
						max: this.max,
						// interval: 10,
						interval: this.interval,
						nameTextStyle: { fontSize: 17, padding: [0, 0, 5, 90], fontWeight: 'bold' },
						axisTick: {
							// alignWithLabel: true,
							show: false
						}
					}
				],
				dataZoom: [
					{
						show: false,
						start: 0,
						end: 100
					},
					{
						type: 'inside',
						start: 0,
						end: 100
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: 'empty',
						width: 30,
						height: '80%',
						showDataShadow: false,
						left: '93%'
					}
				],
				series: this.classData
			})
		}
	}
}
</script>

<style></style>
